import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';

export class Beruf {
  constructor({
    id,
    markierung,
    name,
    abkuerzung,
    istAusbildung,
  }: {
    id: string;
    markierung: Markierung;
    name: string;
    abkuerzung: string;
    istAusbildung: boolean;
  }) {
    this.id = id;
    this.markierung = markierung;
    this.name = name;
    this.abkuerzung = abkuerzung;
    this.istAusbildung = istAusbildung;
  }

  id: string;
  markierung: Markierung;
  name: string;
  abkuerzung: string;
  istAusbildung: boolean;
}
